import React from 'react';
import {
  Box,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';

const AnnouncementBanner = ({
  announcement,
  backgroundColor = '#3478F6',
  textColor = '#FFFFFF',
  onClose,
  publishedDate,
  createdBy
}) => {
const formattedDate = publishedDate
  ? moment(publishedDate).format('MMM D, YYYY')
  : '';

if (!announcement) {
  return null;
}

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        minHeight: '34px',
        backgroundColor: '#F2C23F',
        color: '#000000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px 60px 8px 260px',
        boxSizing: 'border-box',
        borderRadius: '6px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
      }}
    >

      {formattedDate && (
        <Typography
          sx={{
            position: 'absolute',
            left: 20,
            top: '50%',
            transform: 'translateY(-50%)',
            width: '220px',
            fontSize: '14px',
            fontWeight: 500,
            color: '#000000',
            whiteSpace: 'normal',
            lineHeight: 1.4,
          }}
        >
          {formattedDate}
        </Typography>
      )}

      <Typography
        sx={{
          width: '100%',
          fontSize: '14px',
          fontWeight: 500,
          textAlign: 'center',
          lineHeight: 1.5,
          wordBreak: 'break-word',
        }}
      >
        {`${createdBy}:  ${announcement}`}
      </Typography>

      <IconButton
        size="small"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 12,
          top: '50%',
          transform: 'translateY(-50%)',
          color: '#000000',
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>

    </Box>
  );
};

export default AnnouncementBanner;